import { createFileRoute } from "@tanstack/react-router";
import { heritageCityRoute } from "@/lib/seo/heritageCityRoute";

export const Route = createFileRoute("/heritage/malmo")(
  heritageCityRoute({
    citySlug: "malmo",
    angle:
      "I Malmö och Öresundsregionen dokumenterar vi livsberättelser för familjer och kunskapsarv för SaaS-, life science- och konsumentbolag på båda sidor om sundet.",
    localUseCases: [
      "Filmad livsintervju hemma i Malmö eller Lund",
      "Grundarporträtt för SaaS- och deeptech-bolag",
      "Kunskapsöverföring i life science och MedTech",
      "Företagshistoria för konsumentvarumärken",
      "Bilaterala produktioner mot Köpenhamn",
      "Minnesfilm och släktarv i Skåne",
    ],
  }),
);
